import { resolveFireCount } from "./projectileCount.js";

export interface SpaceshipProjectileMuzzleLike {
  readonly offsetX: number;
  readonly offsetY: number;
}

export function spaceshipMuzzlesForFlow<T extends SpaceshipProjectileMuzzleLike>(
  muzzles: readonly T[],
  flowIndex: number | undefined,
  flowCount: number,
): readonly T[] {
  if (muzzles.length <= 1 || flowIndex === undefined) return muzzles;
  const safeFlowCount = Math.max(1, Math.floor(flowCount));
  if (safeFlowCount <= 1) return muzzles;
  const index = Math.min(safeFlowCount - 1, Math.max(0, Math.floor(flowIndex)));
  const start = Math.floor((index * muzzles.length) / safeFlowCount);
  const end = Math.max(start + 1, Math.floor(((index + 1) * muzzles.length) / safeFlowCount));
  return muzzles.slice(start, Math.min(muzzles.length, end));
}

export function resolveSpaceshipProjectileCount(
  baseProjectileCount: number,
  muzzleCount: number,
  remainingSlots: number,
): number {
  if (remainingSlots <= 0) return 0;
  const safeMuzzleCount = Math.max(1, Math.floor(muzzleCount));
  return Math.min(resolveFireCount(baseProjectileCount * safeMuzzleCount), Math.floor(remainingSlots));
}
